import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { InvoicePaymentLinkRead } from 'src/common/external/bambi-api/bambiApi';
import { currencyFormatter } from 'src/features/billing/invoices/forms/cells/utils';

import { InvoiceLinkCell } from './InvoiceLinkCell';

const columnHelper = createColumnHelper<InvoicePaymentLinkRead>();

export const paymentLinksColumns = [
  columnHelper.accessor('invoice_number', {
    header: 'Invoice',
    cell: ({ row }) => (
      <InvoiceLinkCell
        invoiceNumber={row.original.invoice_number}
        invoiceId={row.original.invoice}
      />
    ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('payment_portal_url', {
    header: 'Link',
    cell: ({ row }) => (
      <div>
        <a
          className="text-blue-500 underline"
          href={row.original.payment_portal_url}
        >
          Payment Link
        </a>
      </div>
    ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('is_expired', {
    header: 'Expired',
    cell: ({ row }) => <div>{row.original.is_expired ? 'Yes' : 'No'}</div>,
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('email_message', {
    header: 'Emailed?',
    cell: ({ row }) => <div>{row.original.email_message ? 'Yes' : 'No'}</div>,
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('email_to', {
    header: 'Email To',
    cell: ({ row }) => <div>{row.original.email_to || ''}</div>,
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('amount_cents', {
    header: 'Amount',
    cell: ({ row }) => (
      <div>{currencyFormatter(row.original.amount_cents / 100)}</div>
    ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('created_at', {
    header: 'Created On',
    cell: ({ row }) => (
      <div>
        {DateTime.fromISO(row.original.created_at).toLocaleString(
          DateTime.DATETIME_MED
        )}
      </div>
    ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
];
